import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../NotFound'

import { AbilityContext } from '../../components/Ability'
import DailyReportPage from './Features/DailyReport'
import DailySalesReportPage from './Features/DailySalesReport'
import DailyOrdersReportPage from './Features/DailyOrdersReport'
import SendItemsReportPage from './Features/SendItemsReport'
import CommissionReportPage from './Features/CommissionReport'
import CodCheckerPage from './Features/CodChecker'
import CustomerReportPage from './Features/CustomerReport'
import CommissionCancelledReportPage from './Features/CommissionCancelledReport'
import DailyCalendarOrderReportPage from './Features/DailyCalendarOrderReport'

const ReportsPage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/"
        element={
          ability.can('manage', 'Report', 'daily') ? (
            <DailyReportPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/sales-daily"
        element={
          ability.can('manage', 'Report', 'sale') ? (
            <DailySalesReportPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/orders-daily"
        element={
          ability.can('manage', 'Report', 'order') ? (
            <DailyOrdersReportPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/send-items"
        element={
          ability.can('manage', 'Report', 'delivery') ? (
            <SendItemsReportPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/calendar"
        element={
          ability.can('manage', 'Report', 'calendar') ? (
            <DailyCalendarOrderReportPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/commission"
        element={
          ability.can('manage', 'Report', 'commission') ||
          ability.can('manage', 'Report', 'commissionLimit') ? (
            <CommissionReportPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/commission-cancelled"
        element={
          ability.can('manage', 'Report', 'commission-cancelled') ? (
            <CommissionCancelledReportPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/cod-checker"
        element={
          ability.can('manage', 'Report', 'cod') ? (
            <CodCheckerPage />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path={'/customer'}
        element={
          ability.can('manage', 'Report', 'customer') ? (
            <CustomerReportPage />
          ) : (
            <NotFound />
          )
        }
      />
    </Routes>
  )
}

export default ReportsPage
